import rocketBoyImg from '../../../assets/images/barbfullLogo.png';
import AccountInfo from './AccountInfo';
import LinkAccounts from './LinkAccounts';
import Entitlements from './Entitlements';
import PasswordAndSecurity from './PasswordAndSecurity';
import CommunicationPreferences from './CommunicationPreferences';
import RequestData from './RequestData';
import Footer from '../../../components/Footer';
import ReferFriend from './ReferFriend';

const TabContent = ({ activeContent, handleTabChange }) => {
  let content = '';

  switch (activeContent.id) {
    case 1:
      content = <AccountInfo handleTabChange={handleTabChange} />;
      break;
    case 2:
      content = <Entitlements />;
      break;
    case 3:
      content = <PasswordAndSecurity />;
      break;
    case 4:
      content = <CommunicationPreferences />;
      break;
    case 5:
      content = <ReferFriend />;
      break;
    case 6:
      content = <RequestData handleTabChange={handleTabChange} />;
      break;
    case 7:
      content = <LinkAccounts handleTabChange={handleTabChange} />;
      break;
    case 8:
      content = '';
      break;
    default:
      content = '';
  }

  return (
    <div className="overflow-auto px-5 pt-28 lg:px-20 ">
      <div className="max-w-[350px]">
        <img src={rocketBoyImg} alt="build rocket boy" className="w-full mb-5" />
      </div>
      <h1 className="font-Korolev-Bold text-xl uppercase mb-2">{activeContent.label}</h1>

      <div
        className="flex flex-col max-w-4xl  min-h-[calc(100vh_-_200px)] overflow-scroll-y tabContent"
        id="tabContent">
        {content}
        <div className="grow"></div>

        <Footer />
      </div>
    </div>
  );
};

export default TabContent;
